import { memo } from 'react'
import { ButtonBase, SxProps } from '@mui/material'
import { CrossThinIcon } from '@/assets'
import { Box } from '@/components/Layout'
import { Text } from '@/components/Data'
import { useTranslations } from '@/core/translation'
import { sidebarHistoryStyles as styles } from '../SidebarHistory.style'
import { useHistoryItemController } from './HistoryItem.controller'
import { HistoryItemProps } from './HistoryItem.types'

function HistoryItem(props: HistoryItemProps) {
  const { item, isActive } = props
  const t = useTranslations('sidebar')
  const { onOpenClick, onRemoveClick } = useHistoryItemController(props)

  return (
    <Box sx={[styles.item, isActive && styles.itemActive] as SxProps}>
      <ButtonBase
        sx={styles.itemButton}
        onClick={onOpenClick}
        aria-current={isActive}
        title={item.title}>
        <Text component="span" sx={[styles.itemText, isActive && styles.itemTextActive] as SxProps}>
          {item.title}
        </Text>
      </ButtonBase>

      <ButtonBase
        className="history-remove"
        aria-label={t('removeConversation')}
        sx={styles.remove}
        onClick={onRemoveClick}>
        <Box component={CrossThinIcon} sx={styles.removeIcon} />
      </ButtonBase>
    </Box>
  )
}

export default memo(HistoryItem)
